"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbnailList = exports.ThumbnailInner = exports.ThumbnailCaption = exports.ThumbnailBase = exports.Root = exports.Remaining = exports.PlayIcon = exports.MainImageWrapperBase = exports.MainImageWrapper = exports.ClassicThumbnailRoot = exports.Caption = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = require("../colors");
var _isNucleus = _interopRequireDefault(require("../utils/isNucleus"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PlayIcon = _styledComponents["default"].span.attrs({
  className: 'mw-icon-play'
}).withConfig({
  displayName: "styles__PlayIcon",
  componentId: "sc-10zajq9-0"
})(["font-size:30px;background-color:rgba(255,255,255,0.5);line-height:30px;background-position:-32px 210px;width:30px;position:absolute;left:0;top:50%;z-index:2;margin:auto;transform:translateY(-50%);border-radius:5px;right:0px;"]);
exports.PlayIcon = PlayIcon;
var ThumbnailInner = _styledComponents["default"].div.withConfig({
  displayName: "styles__ThumbnailInner",
  componentId: "sc-10zajq9-1"
})(["position:relative;display:flex;overflow:hidden;max-width:100%;img{height:71px;@media (min-width:768px){height:88px;}}"]);
exports.ThumbnailInner = ThumbnailInner;
var Root = _styledComponents["default"].div.withConfig({
  displayName: "styles__Root",
  componentId: "sc-10zajq9-2"
})(["display:flex;flex-flow:column;@media (min-width:577px){flex-flow:row-reverse nowrap;}"]);

// only used in classic theme, as the name suggests
exports.Root = Root;
var ClassicThumbnailRoot = _styledComponents["default"].div.attrs(function (props) {
  return {
    role: 'presentation',
    className: props.selected && 'pip-components__Visualizer--ClassicThumbnailRoot-selected'
  };
}).withConfig({
  displayName: "styles__ClassicThumbnailRoot",
  componentId: "sc-10zajq9-3"
})(["padding-bottom:1px;border-bottom:3px solid transparent;&.pip-components__Visualizer--ClassicThumbnailRoot-selected,&:hover{border-bottom:3px solid ", ";}"], _colors.thdOrange);
exports.ClassicThumbnailRoot = ClassicThumbnailRoot;
var ThumbnailBase = _styledComponents["default"].div.attrs(function (props) {
  return {
    role: 'presentation',
    className: props.selected && 'pip-components__Visualizer--ThumbnailBase-selected'
  };
}).withConfig({
  displayName: "styles__ThumbnailBase",
  componentId: "sc-10zajq9-4"
})(["position:relative;cursor:pointer;border:1px solid #ccc;border-radius:3px;box-sizing:border-box;width:73px;height:fit-content;display:flex;flex-direction:column;justify-content:flex-start;@media (min-width:768px){width:90px;}", ""], function (props) {
  return (0, _isNucleus["default"])(props) && !props.showSkeleton && (0, _styledComponents.css)(["&.pip-components__Visualizer--ThumbnailBase-selected,&:hover{border:3px solid ", ";}"], _colors.thdOrange);
});
exports.ThumbnailBase = ThumbnailBase;
var ThumbnailList = _styledComponents["default"].div.withConfig({
  displayName: "styles__ThumbnailList",
  componentId: "sc-10zajq9-5"
})(["display:flex;flex-direction:column;& > div{margin:0 12px 8px 0;}"]);

// TODO: move elsewhere, reuse for modals
exports.ThumbnailList = ThumbnailList;
var Overlay = _styledComponents["default"].div.withConfig({
  displayName: "styles__Overlay",
  componentId: "sc-10zajq9-6"
})(["z-index:4;position:absolute;background-color:rgba(0,0,0,0.6);top:0;left:0;width:100%;height:100%;"]);
var Remaining = (0, _styledComponents["default"])(Overlay).withConfig({
  displayName: "styles__Remaining",
  componentId: "sc-10zajq9-7"
})(["display:flex;flex-direction:column;justify-content:center;text-align:center;color:white;font-size:3.6rem;"]);
exports.Remaining = Remaining;
var MainImageWrapperBase = _styledComponents["default"].div.attrs(function () {
  return {
    role: 'presentation'
  };
}).withConfig({
  displayName: "styles__MainImageWrapperBase",
  componentId: "sc-10zajq9-8"
})(["display:flex;flex-direction:column;align-items:center;text-align:center;cursor:pointer;color:", ";p{margin-top:0.5em;}.pip-components__Visualizer--image-zoomed-container{position:fixed;border:1px solid rgb(148,148,148);}.video-js{margin:0 auto;max-width:100%;}"], _colors.evil);
exports.MainImageWrapperBase = MainImageWrapperBase;
var MainImageWrapper = (0, _styledComponents["default"])(MainImageWrapperBase).withConfig({
  displayName: "styles__MainImageWrapper",
  componentId: "sc-10zajq9-9"
})(["@media (min-width:577px){margin-top:40px;width:calc(100% - 110px);}.pip-components__Visualizer--image-main{max-height:475px;max-width:475px;@media screen and (max-width:576px){max-width:100%;}}.video-js{max-height:475px;}"]);
exports.MainImageWrapper = MainImageWrapper;
var Caption = _styledComponents["default"].div.withConfig({
  displayName: "styles__Caption",
  componentId: "sc-10zajq9-10"
})(["font-size:1.2rem;font-weight:bold;text-align:left;align-self:flex-start;flex-grow:1;display:flex;align-items:flex-end;@media (min-width:768px){font-size:1.8rem;}"]);
exports.Caption = Caption;
var ThumbnailCaption = _styledComponents["default"].div.withConfig({
  displayName: "styles__ThumbnailCaption",
  componentId: "sc-10zajq9-11"
})(["font-size:1.0rem;font-weight:bold;line-height:1.4rem;padding:0.2rem 0.2rem;text-align:left;text-overflow:ellipsis;"]);
exports.ThumbnailCaption = ThumbnailCaption;
//# sourceMappingURL=styles.js.map